import React from 'react';
import {
  VictoryPie,
  VictoryLabel,
  VictoryTooltip,
  VictoryContainer
} from 'victory';
import './Charts.css';

const PieChart = ({ 
  data = [], 
  title = 'Device Distribution',
  colorScale = [
    '#10b981', // emerald
    '#3b82f6', // blue
    '#8b5cf6', // violet
    '#6366f1', // indigo
    '#ec4899'  // pink
  ]
}) => {
  const formattedData = data.map(point => ({
    x: point.device || point.label,
    y: point.count || point.value,
    label: `${point.device || point.label}\n${point.percentage || Math.round((point.count || point.value) * 100) / 100}%`
  }));

  return (
    <div className="chart pie-chart">
      <h3 className="chart-title">{title}</h3>
      <div className="pie-container">
        <VictoryPie
          data={formattedData}
          colorScale={colorScale}
          radius={({ datum }) => 100 + datum.y * 0.1} // Slight 3D effect
          innerRadius={30} // Donut style
          labelComponent={
            <VictoryTooltip
              style={{ fontSize: 10, fill: '#fff' }}
              flyoutStyle={{
                stroke: 'none',
                fill: 'rgba(0, 0, 0, 0.8)'
              }}
            />
          }
          style={{
            data: {
              filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))',
              cursor: 'pointer'
            },
            labels: {
              fill: '#fff',
              fontSize: 10
            }
          }}
          animate={{
            duration: 2000,
            onLoad: { duration: 1000 }
          }}
          events={[{
            target: "data",
            eventHandlers: {
              onMouseEnter: () => ({
                target: "data",
                mutation: (props) => ({
                  radius: props.radius + 10
                })
              }),
              onMouseLeave: () => ({
                target: "data",
                mutation: () => null
              })
            }
          }]}
        />
        <div className="chart-legend">
          {formattedData.map((item, index) => (
            <div key={item.x} className="legend-item">
              <span 
                className="legend-color" 
                style={{ backgroundColor: colorScale[index] }}
              />
              <span>{item.x}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PieChart; 